import * as api from '../api/payment-plans';
import q from '../query';
import { subscribeToEvent } from '../socket';
import { SocketEvent } from '@debbie/common/dist/web-sockets';
export const paymentPlansInsightsKey = `payment-plans-insights`;
export const usePaymentPlansInsights = () => q.query(paymentPlansInsightsKey, api.getInsights, []);
export const paymentPlanLogsKey = (paymentPlanId) => `payment-plans-logs-${paymentPlanId}`;
export const usePaymentPlanLogs = (paymentPlanId) => q.query(paymentPlanLogsKey(paymentPlanId), () => api.getLogsByCaseId(paymentPlanId), []);
export const paymentPlansByCaseIdKey = (caseId) => `payment-plans-by-case-${caseId}`;
export const usePaymentPlansByCaseId = (caseId) => q.query(paymentPlansByCaseIdKey(caseId), () => (caseId ? api.getByCaseId(caseId) : null), [], { enabled: caseId != null });
const paymentPlanChange = (caseId) => {
    q.invalidate([paymentPlansByCaseIdKey(caseId)]);
};
subscribeToEvent(SocketEvent.NEWPAYMENTPLAN, paymentPlanChange);
subscribeToEvent(SocketEvent.PAYMENTPLANMUTATION, paymentPlanChange);
//# sourceMappingURL=index.js.map